<div class="tt-content-switcher" [ngClass]="{ 'tt-content-switcher--stretch': ttStretchWidth }">
    <ng-content></ng-content>
</div>
